import React from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    ImageField,
    ImageInput,
} from "react-admin";
import CreateView from "../../components/CreateView";
import EditView from "../../components/EditView";
import ShowView from "../../components/ShowView";

const EventBannerFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="عنوان"
          source={"title"}
      />
  </Filter>
);

export const EventBannerList = (props) => (
  <List {...props} filters={<EventBannerFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <TextField source="title"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <ImageField source="image"/>
      <TextField source="callToAction"/>
    </Datagrid>
  </List>
);

export const EventBannerCreate = (props) => (
        <CreateView {...props} perPage={10}>
            <TextInput  source="title" validate={required()}/>
            <TextInput source="callToAction"/>
            <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*" validate={required()}>
                <ImageField source="src" title="image"/>
            </ImageInput>
        </CreateView>
)


export const EventBannerEdit = (props) => {
    return (
        <EditView {...props}>
            <TextInput  source="title" validate={required()}/>
            <TextInput source="callToAction"/>
            <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*" validate={required()}>
                <ImageField source="src" title="image"/>
            </ImageInput>
            <TextInput source="image" validate={required()}/>
        </EditView>
    );
}

export const EventBannerShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="objectId"/>
      <TextField source="title"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <ImageField source="image"/>
      <TextField source="callToAction"/>
    </SimpleShowLayout>
  </ShowView>
);
